var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescriptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 10.125C9.27344 10.125 7.125 12.3164 7.125 14.9375V24.5625C7.125 27.2266 9.27344 29.375 11.9375 29.375C14.5586 29.375 16.75 27.2266 16.75 24.5625V14.9375C16.75 12.3164 14.5586 10.125 11.9375 10.125ZM14 19.75H9.875V14.9375C9.875 13.8203 10.7773 12.875 11.9375 12.875C13.0547 12.875 14 13.8203 14 14.9375V19.75ZM19.9727 18.5039C19.8438 18.332 19.5859 18.375 19.457 18.5469C17.5234 21.2109 17.7383 24.9922 20.1445 27.3984C22.5508 29.8047 26.332 30.0195 28.9961 28.0859C29.168 27.957 29.2109 27.6992 29.0391 27.5703L19.9727 18.5039ZM29.8555 17.6875C27.4492 15.2383 23.668 15.0664 21.0039 17C20.832 17.1289 20.7891 17.3867 20.9609 17.5156L30.0273 26.582C30.1562 26.7109 30.4141 26.7109 30.543 26.5391C32.4766 23.875 32.2617 20.0938 29.8555 17.6875Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptions);
export default __webpack_public_path__ + "static/media/prescriptions.a57e35a1.svg";
export { ForwardRef as ReactComponent };